import { useFetch } from '@reveni-io/reveni-ui'

import commonServices from '@/common/services/services'

const useInventoryLocations = ({ storeId }) => {
  const {
    data,
    loading: fetchingInventoryLocations,
    fetchData,
  } = useFetch(() => commonServices.getInventoryLocations({ storeId }), {
    doInitialRequest: !!storeId,
  })

  return {
    inventoryLocations: data?.results || [],
    fetchingInventoryLocations,
    refetchInventoryLocations: fetchData,
  }
}

export default useInventoryLocations
